/**
 * LLM 习惯输出 LaTeX 定界符 \(...\)（行内）与 \[...\]（块级），
 * 而 remark-math 默认只认 $...$ / $$...$$。渲染前把前者归一为后者。
 * 围栏代码块（```）内的内容原样保留；行内代码的边界不处理（接受此边界）。
 */
export const normalizeMathDelimiters = (text: string): string => {
  if (!text.includes("\\(") && !text.includes("\\[")) return text
  // 用捕获组切分：奇数下标为代码块段（含未闭合的流式尾段），不做替换
  const parts = text.split(/(```[\s\S]*?(?:```|$))/)
  return parts
    .map((part, i) => {
      if (i % 2 === 1) return part
      return part
        .replace(/\\\(([\s\S]+?)\\\)/g, (_, expr: string) => `$${expr.trim()}$`)
        .replace(/\\\[([\s\S]+?)\\\]/g, (_, expr: string) => `\n$$\n${expr.trim()}\n$$\n`)
    })
    .join("")
}
